import { BLANK_SHIPPING_LABEL, blankShippingNote, bulkDiscountLine, savedPair } from "../../src/lib/estimate.ts";
import { money } from "../../src/lib/money.ts";
import { h } from "./dom.ts";

// A quantity discount as the server sends it (progress.md D1): the tier and what it saved, as the two prices.
export interface Discount {
  pct: number;
  atCount: number;
  bankCents: number;
  cardCents: number;
}

// The line under the two totals on the designer, the share page and the checkout page:
// "Bulk discount, 24 or more: 15% off" and "You save $34.20 (bank) / $35.56 (card)".
export function discountView(d: Discount): HTMLElement {
  return h("p", { id: "bulk-discount", class: "discount" }, h("b", {}, bulkDiscountLine(d)), h("br"), `You save ${savedPair(d)}`);
}

// Blank shipping above the totals on the designer and the checkout page, laid out like a print tier line: the label
// and its two prices ("Bank $10.10", "Card $10.40"), or "Free" once the order reaches the waiver, and the short note.
export function blankShippingView(b: { bankCents: number; cardCents: number; freeAtCents: number }): HTMLElement {
  const free = b.bankCents === 0 && b.cardCents === 0;
  return h("div", { id: "blank-shipping" },
    h("div", { class: "print-tier" }, h("span", {}, BLANK_SHIPPING_LABEL),
      ...(free ? [h("span", { class: "price" }, "Free")] : [h("span", { class: "price" }, `Bank ${money(b.bankCents)}`), h("span", { class: "price" }, `Card ${money(b.cardCents)}`)])),
    h("p", { class: "muted" }, blankShippingNote(b)));
}
